module.exports = __webpack_public_path__ + "img/cloud.c444c769.png";